import axiosClient from './axiosClient';

const adminKycService = {
    getAll: async () => {
        const response = await axiosClient.get('/admin/kyc');
        return response.data;
    },
    getDetails: async (userId) => {
        const response = await axiosClient.get(`/admin/kyc/user/${userId}`, { skipGlobalToast: true });
        return response.data;
    },
    updateStatus: async (id, status) => {
        const response = await axiosClient.put(`/admin/kyc/${id}/status`, { status });
        return response.data;
    },
    updateNinStatus: async (id, ninStatus, message) => {
        const response = await axiosClient.put(`/admin/kyc/${id}/nin-status`, { ninStatus, message });
        return response.data;
    }
};

export default adminKycService;
